import { apiRequest } from './client.js';
import type { Subscription, Entitlement, AuditLog } from '@hisob/types';
import type { CursorPaginatedResult, OverviewMetrics, SystemHealthStatus } from '../types/index.js';

// Subscriptions API
export async function fetchSubscriptions(): Promise<Subscription[]> {
  const res = await apiRequest<{ items: Subscription[] }>('/api/v1/admin/subscriptions');
  return res.items || [];
}

// Entitlements API
export async function fetchAllEntitlements(): Promise<Entitlement[]> {
  const res = await apiRequest<{ items: Entitlement[] }>('/api/v1/admin/entitlements');
  return res.items || [];
}

// Audit Logs API
export async function fetchAuditLogs(params?: {
  limit?: number;
  cursor?: string;
  action?: string;
  actorId?: string;
  search?: string;
  category?: string;
}): Promise<CursorPaginatedResult<AuditLog> & {
  auth_stats?: {
    otp_sent: number;
    login_success: number;
    login_failed: number;
    telegram_linked: number;
  };
}> {
  return apiRequest('/api/v1/admin/audit-logs', { params });
}

// System Health & Overview API
export async function fetchOverviewMetrics(): Promise<OverviewMetrics> {
  return apiRequest<OverviewMetrics>('/api/v1/admin/overview');
}

export async function fetchSystemHealth(): Promise<SystemHealthStatus> {
  return apiRequest<SystemHealthStatus>('/api/v1/admin/health');
}

